/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export default ({ color = '#FFF', ...props }: SVGAttributes<SVGElement> & { color?: string }) => (
	<svg width="24px" height="24px" viewBox="0 0 24 24" {...props}>
		<path
			d="M13.48 11.184L18.787 5h-1.258l-4.606 5.369L9.243 5H5l5.563 8.119L5 19.603h1.257l4.864-5.67 3.886 5.67h4.243l-5.77-8.42zM11.76 13.19l-.564-.808L6.71 5.949h1.931l3.62 5.192.563.808 4.705 6.748H15.6l-3.84-5.506z"
			fill="#FFFFFF"
		/>
	</svg>
);
